<section class="gwc-checkbox"
	[class.gwc-checkbox--center]="props['center']"
	[class.gwc-checkbox--error]="formControl.touched && !formControl.valid">
	<mat-checkbox color="primary"
		[formControl]="formControl">
		{{ label }}
	</mat-checkbox>
</section>
